import { useEffect, useRef, useState } from "react";
import * as api from '../../../api';
import { useTranslation } from "react-i18next";
import Section from "../../Atoms/Section";
import BlueButton from "../../Atoms/BlueButton";
import Step2 from "../../Components/SDE24/Parcours/Step2";
import PopA1 from "../../Components/SDE24/Parcours/PopA1";
import { formDataToObject } from "../../Utils/Forms";
import { validateStep1ASDE2024, validateStep2SDE2024 } from "../../Utils/Validator";
import { useNavigate } from "react-router-dom";
import H2 from "../../Atoms/H2";
import Spinner from "../../../Plateforme/Atoms/Spinner";

const EditParticipationA = (props) => {

    const [projets, setProjets] = useState([]);

    const [deletedProjets, setDeletedProjets] = useState([]);
    const [step, setStep] = useState(1);
    const [participation, setParticipation] = useState(null);
    const formRef = useRef(null);
    const [event, setEvent] = useState(null);
    const [uid, setUid] = useState(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const { i18n } = useTranslation('common');

    //get eid and uid from url, then get users participations, then get the right one and set it in state
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        const userIdFromParam = new URLSearchParams(window.location.search).get("uid");
        
        if (!eventIdFromParam || !userIdFromParam) {
            console.log("no event id or user id in url");
            return;
        }

        setUid(userIdFromParam);

        api.getEventById({ id: eventIdFromParam }).then((response) => {
            setEvent(response.data);
        }).catch((error) => {
            console.log(error);
        });

        api.GetAllUserDataById({ id: userIdFromParam}).then((response) => {
            setUser(response.data)
        })

        api.getUserParticipations({userid: userIdFromParam}).then((resParticipations) => {
            const matchingParticipation = resParticipations.data.find(participation => participation.eventId === eventIdFromParam);
            if(matchingParticipation) {
                matchingParticipation.data.consent = true;
                setParticipation(matchingParticipation);
                setProjets(matchingParticipation.data.projets.map(proj => {return {...proj, validated: true}}));
                console.log(matchingParticipation);
            }
            setLoading(false);
        })
    }, [])

    //scroll to top on step change
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [step])

    function submit(e) {
        e.preventDefault();
        setLoading(true);
        const submission = new FormData(e.target);

        submission.append("deletedProjets", JSON.stringify(deletedProjets));
        submission.append("projets", JSON.stringify(projets));
        submission.append("userId", uid);
        submission.append("eventId", event._id);

        api.saveSDE24popA(submission).then((response) => {
            console.log("response.data")
            console.log(response.data)
            setLoading(false);
            if (response.data === "success") {
                alert("Données enregistrées");
                navigate("/evenements")
            } else {
                alert("error")
            }
        });
    }

    function nextStep() {
        if (step === 1 && validateStep1()) {
            setStep(step + 1);
        }
        if (step === 2 && validateStep2()) {
            setStep(step + 1);
        }
    }

    function validateStep1() {
        const form = new FormData(formRef.current);
        return validateStep1ASDE2024(form,projets);
    }

    function validateStep2() {
        const form = new FormData(formRef.current);
        return validateStep2SDE2024(form);
    }

    if (loading) {
        return <Section className="padding"><Spinner/></Section>
    }

    return (<>
        {user?.hsCompany?.properties?.name && <Section className="padding"><H2>{user.hsCompany.properties.name}</H2></Section>}
        {participation && <form onSubmit={submit} ref={formRef}>
            <Section className="padding" style={{ display: step === 1 ? 'block' : 'none' }}>
                <PopA1 defaultValues={participation.data} projets={projets} setDeletedProjets={setDeletedProjets} setProjets={setProjets}/>
            </Section>
            <Section className="padding" style={{ display: step === 2 ? 'block' : 'none' }}>
                <Step2 defaultValues={participation.data} />
            </Section>
            <Section className="padding flexblock" style={{ justifyContent: 'center', gap: '40px' }}>
                {step > 1 && <BlueButton onClick={(e) => { e.preventDefault(); setStep(step - 1) }}>{i18n.language === "fr" ? "Précédent" : "Previous"}</BlueButton>}
                {step < 2 && <BlueButton onClick={(e) => { e.preventDefault(); nextStep() }}><img src='/img/fleche_blanche.png' alt='' />{i18n.language === "fr" ? "Suivant" : "Next"}</BlueButton>}
                {step === 2 && <input type="submit" value={i18n.language === "fr" ? "Enregistrer" : "Save"} />}
            </Section>
        </form>}
    </>)
}

export default EditParticipationA;